import React from 'react';
import './UpgradeModal.css';

function UpgradeModal({ isOpen, onClose, reason, currentTier }) {
  if (!isOpen) return null;

  const tiers = [
    {
      name: 'Starter',
      price: '$99',
      events: '5 events/month',
      attendees: '500 attendees/event',
      features: [
        '5 Events per Month',
        '500 Attendees per Event',
        'Face Recognition',
        'SMS Delivery',
        'Basic Analytics',
        'Email Support'
      ],
      url: 'https://eventpiclive.com/pricing'
    },
    {
      name: 'Professional',
      price: '$299',
      events: '20 events/month',
      attendees: '2,000 attendees/event',
      features: [
        '20 Events per Month',
        '2,000 Attendees per Event',
        'Face Recognition',
        'SMS Delivery',
        'Advanced Analytics',
        'Custom Branding',
        'Priority Support'
      ],
      url: 'https://eventpiclive.com/pricing',
      popular: true
    },
    {
      name: 'Enterprise',
      price: 'Custom',
      events: 'Unlimited events',
      attendees: 'Unlimited attendees',
      features: [
        'Unlimited Events',
        'Unlimited Attendees',
        'Face Recognition',
        'SMS Delivery',
        'Advanced Analytics',
        'Custom Branding',
        'White Label',
        'Dedicated Account Manager',
        '24/7 Priority Support'
      ],
      url: 'https://eventpiclive.com/contact'
    }
  ];

  return (
    <div className="upgrade-modal-overlay" onClick={onClose}>
      <div className="upgrade-modal" onClick={(e) => e.stopPropagation()}>
        <button className="upgrade-modal-close" onClick={onClose}>×</button>
        
        <div className="upgrade-modal-header">
          <h2>🚀 Upgrade Your Plan</h2>
          <p className="upgrade-reason">{reason}</p>
          {currentTier && (
            <p className="current-tier">Current Plan: <strong>{currentTier}</strong></p>
          )}
        </div>

        <div className="upgrade-tiers">
          {tiers.map((tier) => (
            <div 
              key={tier.name} 
              className={`upgrade-tier-card ${tier.popular ? 'popular' : ''}`}
            >
              {tier.popular && <div className="popular-badge">Most Popular</div>}
              
              <h3>{tier.name}</h3>
              <div className="tier-price">{tier.price}<span>/month</span></div>
              
              <ul className="tier-features">
                {tier.features.map((feature, index) => (
                  <li key={index}>✓ {feature}</li>
                ))}
              </ul>
              
              <a 
                href={tier.url} 
                className="upgrade-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                {currentTier === tier.name ? 'Current Plan' : 'Upgrade Now'}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default UpgradeModal;
